﻿
export class TripExpense {
        public TRIP_ID!: number;
        public LOC_ID!: number;
        public VH_NO!: string;
        public EXPENSE_DATE!: string;
        public EXPENSE_AMOUNT!: number;
        public VOUCHER_NO!: string;
        public CREATEDBY_USERID!: number;
        public UPDATEDBY_USERID!: number;
        public CREATED_DATE!: string;
        public UPDATED_DATE!: string;
        public IS_ACTIVE!: number;
}
